import {Component, OnInit} from '@angular/core';
import { Disclaimer } from "../../model/Disclaimer";
import {FileuploadService} from "../../service/http/fileupload.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {SuccessSaveToastComponent} from '../../toast/success-save-toast/success-save-toast.component';
import {MatDialog, MatSnackBar} from '@angular/material';
import {SuccessMessageToastComponent} from '../../toast/success-message-toast/success-message-toast.component';
import {DeleteDisclaimerTemplateComponent} from './delete-disclaimer-template/delete-disclaimer-template.component';
import {AcceptDeclineDialogComponent} from '../../dialog/accept-decline-dialog/accept-decline-dialog.component';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-workflow-step-disclaimer',
  templateUrl: './workflow-step-disclaimer.component.html',
  styleUrls: ['./workflow-step-disclaimer.component.css']
})
export class WorkflowStepDisclaimerComponent implements OnInit {

  public disclaimerTitle: string;
  public disclaimerParagraph: string[];
  currentPackageId: string;

  public templateLoadName:string="";
  public templateName:string="";
  public templateList:string[];

  public listUpdateOk=true;

  titleFormControl = new FormControl('', [
    Validators.required
  ]);
  textareaFormControl = new FormControl('', [
  ]);
  public disclaimerFormGroup = new FormGroup({
    title: this.titleFormControl,
    textarea0: this.textareaFormControl
  });

  constructor(private uploadService: FileuploadService,
              public snackBar: MatSnackBar,
              public dialog: MatDialog,
              private translate: TranslateService) { }

  ngOnInit() {
    this.currentPackageId = sessionStorage.getItem('currentPackageId');
    this.uploadService.getDisclaimerTemplateList().subscribe(data=>{
      this.templateList=data;
    });

    if(this.currentPackageId !== null) {

      this.uploadService.getDisclaimer(this.currentPackageId).subscribe(data => {
        this.disclaimerTitle=data[0]["title"];
        this.disclaimerParagraph=  data[0]["paragraphs"];
        this.disclaimerFormGroup.setValue({
          title: data[0]["title"],
          textarea0: data[0]["paragraphs"][0]
        });

        for(let i=1; i < data[0]["paragraphs"].length; i++) {
          this.disclaimerFormGroup.addControl('textarea' + (i), this.textareaFormControl);
        }

      });
    }
  }
  loadTemplate(){
    this.uploadService.getDisclaimerTemplate(this.templateLoadName).subscribe(data => {
      this.disclaimerTitle=data.title;
      this.disclaimerParagraph=data.paragraphs;
    });
  }

  private getDisclaimer():Disclaimer{
    let paragraphs: string[] = [];

    for(let i=0; i<this.disclaimerParagraph.length; i++) {
      paragraphs.push(this.disclaimerParagraph[i]);
    }
    return new Disclaimer(this.disclaimerTitle, paragraphs);
  }

  sendDisclaimer() {
    this.uploadService.uploadDisclaimer(this.getDisclaimer(), this.currentPackageId).subscribe();
  }

  saveTemplate(){
    let disclaimer: Disclaimer = this.getDisclaimer();

    let disclaimerTemplateName = this.templateName.replace(/ /g,"_").replace(/[^\w_]/g,"");

    if(this.templateList.includes(disclaimerTemplateName)) {

      const dialogOverwriteTemplate = this.dialog.open(AcceptDeclineDialogComponent, {
        width: '250px',
        data: {
          title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
          message: this.translate.instant('A template with the same name already exists, do you want to overwrite it?'),
          icon: {
            add: false,
            name: ''
          }
        }
      });

      dialogOverwriteTemplate.afterClosed().subscribe(result => {
        if(result == true) {
          this.saveDisclaimerTemplateAfterChecks(disclaimer, disclaimerTemplateName);
        }
      });

    } else {
      this.saveDisclaimerTemplateAfterChecks(disclaimer, disclaimerTemplateName);
    }

  }


  private saveDisclaimerTemplateAfterChecks(disclaimer: Disclaimer, disclaimerTemplateName: string) {

    this.uploadService.uploadDisclaimerTemplate(disclaimer, disclaimerTemplateName).subscribe(data => {

      let toast = this.snackBar.openFromComponent(SuccessSaveToastComponent, {
        duration: 2000,
        panelClass: ['white-snackbar']
      });

      this.uploadService.getDisclaimerTemplateList().subscribe(data => {
        this.templateList = data;
      });

    });

  }


  deleteDisclaimerTemplate() {

    let delDisclaimerDialog = this.dialog.open(DeleteDisclaimerTemplateComponent, {
      width: '23%',
      height: '10%',
      data: {
        disclaimerTemplateList: this.templateList }
    });

    delDisclaimerDialog.afterClosed().subscribe(result => {
      this.uploadService.getDisclaimerTemplateList().subscribe(data => {

        let toast = this.snackBar.openFromComponent(SuccessMessageToastComponent, {
          duration: 2000,
          panelClass: ['white-snackbar']
        });

        this.templateList = data;
      });
    });

  }

  paragraphChange(i:number, text: string){
    this.disclaimerParagraph[i]=text;
  }

  titleChange(text: string){
    this.disclaimerTitle=text;
  }

  add() {
    this.disclaimerParagraph.push("");
  }

  remove() {
    this.disclaimerParagraph.pop();
  }

  trackByFn(index:number, item:string):number{
    return index;
  }
}
